import { Div } from '@vgrubs/components';
import React, { useState } from 'react';

export const RatingInput = ({
  fixedStars = null,
  size = 24,
  gap = '10px',
  onRatingChange,
  selectedStars,
}: {
  fixedStars?: number | null;
  size?: number;
  gap?: string;
  onRatingChange?: (rating: number) => void;
  selectedStars?: number;
}) => {
  const [activeStars, setActiveStars] = useState(fixedStars ?? 0);
  return (
    <Div
      onMouseLeave={() => {
        if (fixedStars !== null) {
          return;
        }
        setActiveStars(0);
      }}
      $flex
      $gap={gap}
    >
      {[...Array(5)].map((_, index) => {
        return (
          <div
            key={index}
            onMouseEnter={() => {
              if (fixedStars !== null) {
                return;
              }
              setActiveStars(index + 1);
            }}
            style={{ cursor: fixedStars ? 'default' : 'pointer' }}
            onClick={() => {
              if (fixedStars !== null) {
                return;
              }
              onRatingChange?.(index + 1);
            }}
          >
            <Star
              percentage={(selectedStars ?? activeStars) - index}
              size={size}
            />
          </div>
        );
      })}
    </Div>
  );
};

export const Star = ({ percentage = 1, size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8062 1.69047C12.6524 1.39047 12.3412 1.19922 12.0037 1.19922C11.6662 1.19922 11.3549 1.39047 11.2012 1.69047L8.4412 7.09797L2.44495 8.05047C2.1112 8.10297 1.8337 8.33922 1.7287 8.66172C1.6237 8.98422 1.70995 9.33672 1.9462 9.57672L6.2362 13.8705L5.2912 19.8667C5.2387 20.2005 5.37745 20.538 5.6512 20.7367C5.92495 20.9355 6.28495 20.9655 6.5887 20.8117L12.0037 18.0592L17.4149 20.8117C17.7149 20.9655 18.0787 20.9355 18.3524 20.7367C18.6262 20.538 18.7649 20.2042 18.7124 19.8667L17.7637 13.8705L22.0537 9.57672C22.2937 9.33672 22.3762 8.98422 22.2712 8.66172C22.1662 8.33922 21.8924 8.10297 21.5549 8.05047L15.5624 7.09797L12.8062 1.69047Z"
        fill={percentage > 0 ? '#FF9800' : '#F2F2F2'}
      />
    </svg>
  );
};
